import { render } from "./AllFiles.vue?vue&type=template&id=3961b4f2"
import script from "./AllFiles.vue?vue&type=script&lang=js"
export * from "./AllFiles.vue?vue&type=script&lang=js"

import "./AllFiles.vue?vue&type=style&index=0&id=3961b4f2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__